module.exports = __webpack_public_path__ + "static/media/dice-one.29f51119.svg";